import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "sentinel",
  class: "text-center q-pa-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_q_spinner, {
              key: 0,
              color: "primary",
              size: "24px"
            }))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}